import { useCallback } from "react";
import { useAsync } from "@/shared/hooks/HookBase";
import type IWorkflowAccessService from "../contracts/IWorkflowAccessService";
import WorkflowAccessService from "../services/WorkflowAccessService";
import type WorkflowAccess from "../models/WorkflowAccess";

const workflowAccessService: IWorkflowAccessService = new WorkflowAccessService();

export function useWorkflowAccess() {
  const { loading, error, execute } = useAsync();

  const getByWorkflow = useCallback(
    async (workflowId: string): Promise<WorkflowAccess[] | void> => {
      return await execute(() => workflowAccessService.GetByWorkflow(workflowId));
    },
    [execute],
  );

  const grant = useCallback(
    async (workflowId: string, grantedToUserId: string): Promise<WorkflowAccess | void> => {
      return await execute(() => workflowAccessService.Grant(workflowId, grantedToUserId), {
        successMessage: "Automatización compartida correctamente",
      });
    },
    [execute],
  );

  const update = useCallback(
    async (workflowId: string, accessId: string, enabled: boolean): Promise<void> => {
      return await execute(() => workflowAccessService.Update(workflowId, accessId, enabled), {
        successMessage: enabled ? "Acceso reactivado" : "Acceso suspendido",
      });
    },
    [execute],
  );

  const revoke = useCallback(
    async (workflowId: string, accessId: string): Promise<void> => {
      return await execute(() => workflowAccessService.Revoke(workflowId, accessId), {
        successMessage: "Acceso revocado correctamente",
      });
    },
    [execute],
  );

  return { loading, error, getByWorkflow, grant, update, revoke };
}
